export default {
  preferences: {
    title: "Preferências",
    promo: {
      blurb: "Jogadas avançadas.\nInsights mais profundos.",
    },
    sections: {
      account: "Conta",
      display: "Exibição",
      support: "Suporte",
      about: "Sobre",
    },
    items: {
      profile: "Perfil",
      location: "Localização",
      manageSubscription: "Gerenciar assinatura",
      glossary: "Glossário",
      contactSupport: "Entrar em contato com o suporte",
      logOut: "Sair",
      deleteAccount: "Excluir conta",
    },
    profile: {
      title: "Perfil",
      alerts: {
        passwordMessage: "Para alterar sua senha, acesse linemate.io",
        usernameInvalid: "Seu nome de usuário precisa ter pelo menos 6 caracteres. Use apenas letras e números.",
        usernameTaken: "Nome de usuário já está em uso",
      },
      saved: "Perfil salvo",
    },
    display: {
      preferences: {
        theme: "Tema",
        odds: "Odds",
        language: "Idioma",
      },
      options: {
        theme: {
          "Match System": "Usar sistema",
          Light: "Claro",
          Dark: "Escuro",
        },
        odds: {
          american: "Americano",
          decimal: "Decimal",
        },
      },
    },
    language: {
      loading: "Atualizando idioma...",
    },
    about: {
      terms: "Termos",
      privacy: "Privacidade",
      responsibleGambling: "Jogo responsável",
      openSourceLibraries: "Bibliotecas de código aberto",
      acknowledgments: "Agradecimentos",
    },
    subscription: {
      alertTitle: "Assinatura",
      webMessage: "Para gerenciar sua assinatura, visite a seção de perfil em linemate.io",
      googlePlayMessage: "Para gerenciar sua assinatura, visite a seção Assinaturas da conta Google Play associada a esta compra",
      appleMessage: "Para gerenciar sua assinatura, visite a seção Assinaturas da conta Apple associada a esta compra",
      manageTitle: "Gerenciar assinatura",
      currentPlan: "Plano atual",
      changePlan: "Alterar plano",
      cancelPlan: "Cancelar assinatura",
      cancelTitle: "Cancelar assinatura",
      cancelHeading: "Por que você está cancelando?",
      cancelSubtitle: "Seu feedback nos ajudará a melhorar o produto.",
      missingTitle: "O que está faltando?",
      missingSubtitle: "Quais recursos ou ferramentas tornariam o Linemate mais valioso para você?",
      improveTitle: "Conte como podemos melhorar",
      improveSubtitle: "Seu feedback nos ajuda a melhorar.",
      trialActive: "Seu teste do Linemate+ ainda está ativo.",
      alreadyActive: "Você já tem acesso ao Linemate+",
      exclusiveOfferFallbackTitle: "Oferta exclusiva",
      exclusiveOfferFallbackSubtitle: "Mantenha seu acesso com uma oferta por tempo limitado antes de cancelar.",
      claimOneTimeOffer: "Resgatar oferta única",
      offerApplyFailure: "Não foi possível aplicar esta oferta agora. Tente novamente mais tarde.",
      continueToCancel: "Continuar para cancelar",
      losingAccessTitle: "Você perderá acesso aos nossos recursos avançados mais recentes",
      losingAccessSubtitle: "Veja o que você perderá quando seu plano terminar.",
      keepSubscription: "Manter assinatura",
      feedbackPlaceholder: "Digite sua resposta...",
    },
    providers: {
      locationTitle: "Permita que o Linemate acesse sua localização para definir suas odds preferidas",
      locationSubtitle: "O Linemate usa sua localização para mostrar provedores na sua região",
    },
    location: {
      title: "Localização",
      useCurrentLocation: "Usar localização atual",
      enableLocationMessage: "Economize tempo e permita o compartilhamento de localização para mostrarmos os melhores mercados e ofertas.",
    },
    logout: {
      title: "Sair",
      message: "Tem certeza de que deseja sair?",
    },
    deleteAccount: {
      warningTitle: "Aviso",
      warningMessage: "Você tem uma assinatura ativa; será necessário cancelá-la antes de excluir sua conta.",
      confirmTitle: "Excluir conta",
      confirmMessage: "Tem certeza de que deseja excluir sua conta?",
      confirmAction: "Excluir",
      successTitle: "Excluir conta",
      successMessage: "Sua conta foi excluída com sucesso.",
      errorTitle: "Erro",
    },
    communication: {
      title: "Comunicação",
      email: "E-mail",
      emailDescription: "E-mails de marketing, atualizações de pesquisa, novidades do produto e anúncios ocasionais da plataforma.",
      notificationSettings: "Configurações de notificação",
      notificationDescription: "Notificações de marketing, lembretes antes de janelas importantes de jogos e novidades sobre recursos.",
    },
    feedback: {
      title: "Enviar feedback",
      enjoymentPrompt: "Você está gostando da experiência?",
      improvePrompt: "Conte como podemos melhorar. Todo feedback ajuda.",
      actions: {
        yes: "Sim",
        no: "Não",
        contactUs: "Fale conosco",
        notNow: "Agora não",
      },
      communication: {
        title: "Comunicação",
        email: "E-mail",
        emailDescription: "E-mails de marketing, atualizações de pesquisa, novidades do produto e anúncios ocasionais da plataforma.",
        notificationSettings: "Configurações de notificação",
        notificationDescription: "Notificações de marketing, lembretes antes de janelas importantes de jogos e novidades sobre recursos.",
      },
    },
  },
};
